import http from './ajax';
export default {

  // 获取用户配额查询
  config(params) {
    return http.get('/api/flow/config/query', params);
  },

  // 用户超限量超额查询
  doseQuery(params) {
    return http.get('/api/flow/overrun/dose/query', params);
  },

  // 用户超限量QPS查询
  qpsQuery(params) {
    return http.get('/api/flow/overrun/qps/query', params);
  },

  // 用户流量查询
  detail(params) {
    return http.get('/api/flow/detail/query', params);
  }

};
